import Component from '@glimmer/component'
import { action } from '@ember/object'
import { queryParam } from 'teacher-ui-client/decorators/query-param'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import {
  serialize as serializeSort,
  deserialize as deserializeSort,
  updateSortColumns,
} from '@blakeelearning/data-tables/utils/sorting'
import { TabGroupComponent } from 'teacher-ui-client/components/tab-group'
import { TAB_TYPE_KEYS } from 'teacher-ui-client/components/tab-group/tab-types'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'
import { ContentTile } from 'teacher-ui-client/components/tiles/content'
import { TaskState } from 'teacher-ui-client/components/task-state'
import { SkillsMasteredStudentsResults } from 'teacher-ui-client/components/tables/skills-mastered/students-results'
import { BasePageSelector } from 'teacher-ui-client/components/base/page-selector'
import type ReportingSkillsMasteredCohortStudentsResultsRoute from 'teacher-ui-client/reporting/ui-scope/maths/skills-mastered/cohort/students-results/route'
import { t } from 'ember-intl'

interface Args {
  model: ModelFor<ReportingSkillsMasteredCohortStudentsResultsRoute>
}

interface Signature {
  Args: Args
}

export class SkillsMasteredCohortStudentsResults extends Component<Signature> {
  @queryParam('reporting/ui-scope/maths/skills-mastered/cohort/students-results') sort!: string

  @queryParam('reporting/ui-scope/maths/skills-mastered/cohort/students-results') gradePosition!: number

  get sortingConfig() {
    return deserializeSort(this.sort)
  }

  set sortingConfig(newSortConfig) {
    this.sort = serializeSort(newSortConfig)
  }

  subscriptionType = SubscriptionType.Maths

  @action
  setGradePosition(gradePosition: number) {
    this.gradePosition = gradePosition
  }

  @action
  updateSort(sortKey: string) {
    this.sortingConfig = updateSortColumns(this.sortingConfig, sortKey)
  }

  <template>
    <TabGroupComponent @theme={{themeKey this.subscriptionType}} @tabType={{TAB_TYPE_KEYS.shadow}} as |tabGroup|>
      <tabGroup.linkToTab @route="reporting.ui-scope.maths.skills-mastered.cohort.students-results">
        {{t "reporting.maths.skillsMastered.cohort.studentsResults.tabTitle"}}
      </tabGroup.linkToTab>
    </TabGroupComponent>
    <ContentTile class="relative rounded-tl-none print:border-none">
      <div class="bg-ms-green-100 h-3"></div>

      <TaskState @task={{@model.fetchStats}} @initialLoadingClass="m-3" as |lastValue isRunning|>
        <SkillsMasteredStudentsResults
          data-test-students-results-table
          class="mt-3"
          @themeKey={{themeKey this.subscriptionType}}
          @studentsData={{lastValue.students}}
          @lessonItemsByGrade={{@model.lessonItemsByGrade}}
          @isLoading={{isRunning}}
          @sortingConfig={{this.sortingConfig}}
          @updateSort={{this.updateSort}}
          @gradePosition={{this.gradePosition}}
          @setGradePosition={{this.setGradePosition}}
          @studentRoute="reporting.ui-scope.maths.student-summary.table"
        />
        <BasePageSelector
          class="my-3"
          @pageCount={{lastValue.meta.total_pages}}
          @itemCount={{lastValue.meta.total_entries}}
        />
      </TaskState>
    </ContentTile>
  </template>
}

export default SkillsMasteredCohortStudentsResults
